import { z } from "zod";
//#region src/alerts/alerts.ts
const Recipient = z.object({
	userId: z.number(),
	teamId: z.number(),
	email: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	isAdmin: z.boolean()
});
var RecipientGroup = /* @__PURE__ */ function(RecipientGroup) {
	RecipientGroup["ALL"] = "ALL";
	RecipientGroup["ADMIN"] = "ADMIN";
	return RecipientGroup;
}(RecipientGroup || {});
var ErrorAlertInterval = /* @__PURE__ */ function(ErrorAlertInterval) {
	ErrorAlertInterval["MINUTES_2"] = "MINUTES_2";
	ErrorAlertInterval["MINUTES_5"] = "MINUTES_5";
	ErrorAlertInterval["MINUTES_10"] = "MINUTES_10";
	ErrorAlertInterval["MINUTES_15"] = "MINUTES_15";
	return ErrorAlertInterval;
}(ErrorAlertInterval || {});
var ErrorAlertFrequency = /* @__PURE__ */ function(ErrorAlertFrequency) {
	ErrorAlertFrequency["MINUTES_2"] = "MINUTES_2";
	ErrorAlertFrequency["MINUTES_5"] = "MINUTES_5";
	ErrorAlertFrequency["MINUTES_10"] = "MINUTES_10";
	ErrorAlertFrequency["MINUTES_15"] = "MINUTES_15";
	ErrorAlertFrequency["MINUTES_30"] = "MINUTES_30";
	ErrorAlertFrequency["HOURS_1"] = "HOURS_1";
	ErrorAlertFrequency["HOURS_4"] = "HOURS_4";
	ErrorAlertFrequency["HOURS_12"] = "HOURS_12";
	ErrorAlertFrequency["HOURS_24"] = "HOURS_24";
	return ErrorAlertFrequency;
}(ErrorAlertFrequency || {});
var ErrorAlertType = /* @__PURE__ */ function(ErrorAlertType) {
	ErrorAlertType["ERROR_RATE"] = "ERROR_RATE";
	return ErrorAlertType;
}(ErrorAlertType || {});
var UsageAlertType = /* @__PURE__ */ function(UsageAlertType) {
	UsageAlertType["ON_DEMAND_CU"] = "ON_DEMAND_CU";
	UsageAlertType["ON_DEMAND_DOLLAR"] = "ON_DEMAND_DOLLAR";
	UsageAlertType["THRESHOLD_FROM_ZERO_CU"] = "THRESHOLD_FROM_ZERO_CU";
	UsageAlertType["THRESHOLD_FROM_ZERO_DOLLAR"] = "THRESHOLD_FROM_ZERO_DOLLAR";
	return UsageAlertType;
}(UsageAlertType || {});
var AlertKind = /* @__PURE__ */ function(AlertKind) {
	AlertKind["ERROR"] = "ERROR";
	AlertKind["USAGE"] = "USAGE";
	return AlertKind;
}(AlertKind || {});
var ChannelType = /* @__PURE__ */ function(ChannelType) {
	ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
	ChannelType["SLACK"] = "SLACK";
	ChannelType["TELEGRAM"] = "TELEGRAM";
	return ChannelType;
}(ChannelType || {});
const BaseAlert = z.object({
	id: z.number(),
	teamId: z.number(),
	active: z.boolean(),
	name: z.string(),
	recipients: z.array(Recipient),
	recipientGroups: z.array(z.nativeEnum(RecipientGroup)),
	vipChannel: z.nativeEnum(ChannelType).optional(),
	appIds: z.array(z.number()).optional(),
	networks: z.array(z.string()).optional(),
	methods: z.array(z.string()).optional()
});
const ErrorAlert = BaseAlert.merge(z.object({
	type: z.nativeEnum(ErrorAlertType),
	interval: z.nativeEnum(ErrorAlertInterval),
	frequency: z.nativeEnum(ErrorAlertFrequency),
	percentThreshold: z.number().int().positive().max(1e4),
	kind: z.literal("ERROR")
}));
const UsageAlert = BaseAlert.merge(z.object({
	type: z.nativeEnum(UsageAlertType),
	threshold: z.number(),
	kind: z.literal("USAGE")
}));
const Alert = z.discriminatedUnion("type", [ErrorAlert, UsageAlert]);
//#endregion
export { Alert, AlertKind, BaseAlert, ChannelType, ErrorAlert, ErrorAlertFrequency, ErrorAlertInterval, ErrorAlertType, Recipient, RecipientGroup, UsageAlert, UsageAlertType };

//# sourceMappingURL=alerts.js.map